<template>
  <div class="basic-block block-advice" :style="styles">
    <img v-if="targetInfo.advice.deco" :src="targetInfo.advice.deco" class="block-advice__deco" alt="">
    <div class="content-wrap">
      <div class="block-advice__inner">
        <h2 class="block-advice__title">
          <span>あなたへのアドバイス</span>
          <lp-alphabet-advice :color="colorScheme.second" />
        </h2>
        <img class="block-advice__img" :src="targetInfo.advice.counselorImage" alt="">
        <p class="block-advice__text">{{ resultData.text5 }}</p>
      </div>
      <a :href="`/recommend/lp/${lpId}/basic/input`" class="block-advice__link" @click.prevent="clicked">︎別の人を占う</a>
    </div>
  </div>
</template>

<script>
import LpAlphabetAdvice from '@/utvStore/components/recommend/lp/partials/LpAlphabetAdvice'

export default {
  name: 'BlockAdvice',
  components: {
    LpAlphabetAdvice,
  },
  props: {
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    resultData: Object,
    lpId: Number,
    pageLabel: String,
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    }
  },
  methods: {
    clicked(e){
      window.gtag('event', 'click', {
        'event_category': `LP${this.lpId}${this.pageLabel}-free-shindan-button`,
      })
      location.href = this.$handoverParams(e.currentTarget.href)
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.block-advice {
  background: #FFFBE3;
  padding: 20px 0 60px;
  &__deco {
    position: absolute;
    top: -45px;
    left: 0;
    width: 17.6%;
    max-width: 80px;
    z-index: 101;
  }
  &__inner {
    margin: 0 20px;
    padding: 29px 20px 24px;
    background: #fff;
  }
  &__title {
    margin: 0 0 40px;
    font-weight: bold;
    font-size: 26px;
    line-height: 1;
    text-align: center;
    color: $l_col_keycolor;
    position: relative;
  }
  &__img {
    display: block;
    margin: 0 auto 16px;
    width: 170px;
  }
  &__text {
    font-weight: bold;
    font-size: 16px;
    line-height: 34px;
    text-align: justify;
    color: $l_col_keycolor;
    // padding: 0 40px;
    margin: 0 auto;
    max-width: 480px;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      bottom: -23px;
      right: 20px;
      width: 44px;
      height: 63px;
      background: url('/static/img/recommend/lp/common/kira.png') no-repeat 0 0/cover;
    }
  }
  &__link {
    display: block;
    margin: 24px 0 0;
    font-weight: 600;
    font-size: 22px;
    line-height: 1;
    text-align: center;
    text-decoration-line: underline;
    color: $l_col_keycolor;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/kurenotori/blocks/BlockAdvice.vue